$(document).ready(function () {
    function getDialogAndTrigger($dialog) {
        const id = $dialog.attr('id');
        const $trigger = $('.gallery-trigger[aria-controls="' + id + '"]');
        return { $dialog, $trigger };
    }

    function focusFirst($dialog) {
        const $focusTarget = $dialog.find('[autofocus], [data-dialog-close], a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .first();

        ($focusTarget[0] || $dialog[0]).focus();
    }

    function openDialog($trigger, $dialog) {
        $trigger.attr('aria-expanded', 'true');
        $dialog.data('returnFocusEl', $trigger[0]);

        // Disable body scroll
        document.body.style.overflow = 'hidden';

        $dialog.addClass('is-opening');
        $dialog[0].showModal();

        requestAnimationFrame(function () {
            $dialog.removeClass('is-opening');
        });

        const $focusTarget = $dialog.find('[autofocus], [data-dialog-close], a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .first();

        ($focusTarget[0] || $dialog[0]).focus();
    }

    function closeDialog($trigger, $dialog) {
        $trigger.attr('aria-expanded', 'false');

        if (!$dialog[0].open) {
            return;
        }

        $dialog.addClass('is-closing');

        window.setTimeout(function () {
            $dialog.removeClass('is-closing');
            $dialog[0].close();

            // Re-enable body scroll
            document.body.style.overflow = '';

            const returnEl = $dialog.data('returnFocusEl');
            if (returnEl && typeof returnEl.focus === 'function') {
                returnEl.focus();
            }
        }, 200);
    }

    // Open
    $(document).on('click', '.gallery-trigger', function () {
        const $trigger = $(this);
        const dialogId = $trigger.attr('aria-controls');
        const $dialog = $('#' + dialogId);

        if (!$dialog.length) {
            return;
        }

        openDialog($trigger, $dialog);
    });

    // Close button
    $(document).on('click', '[data-dialog-close]', function () {
        const $dialog = $(this).closest('dialog.gallery-dialog');
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // ESC: keep state consistent
    $(document).on('cancel', 'dialog.gallery-dialog', function (e) {
        e.preventDefault();
        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // Backdrop click close: only close when the click target is the dialog element
    $(document).on('click', 'dialog.gallery-dialog', function (e) {
        if (e.target !== this) {
            return;
        }

        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // If something else closes it, keep aria-expanded + focus
    $(document).on('close', 'dialog.gallery-dialog', function () {
        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);

        $trigger.attr('aria-expanded', 'false');

        // Re-enable body scroll
        document.body.style.overflow = '';

        const returnEl = $dialog.data('returnFocusEl');
        if (returnEl && typeof returnEl.focus === 'function') {
            returnEl.focus();
        }
    });
});
